import React, { useState } from "react";
import "./Digitalitem.css";
// import "./Physicalitem.css";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";

function Digitalitem() {
  const [statusDrop, setStatusdrop] = useState("Gift Card");
  const [isActive, setActive] = useState(false);

  const handledownload = (e) => {
    const downloadopt = document.getElementById("downloadables");
    setStatusdrop(e.target.innerHTML);
    downloadopt.style.display = "block";
    document.getElementById("gift").style.display = "none";
    document.getElementById("nftupload").style.display = "none";
  };
  const handleGift = (e) => {
    const gift = document.getElementById("gift");
    setStatusdrop(e.target.innerHTML);
    gift.style.display = "block";
    document.getElementById("downloadables").style.display = "none";
    document.getElementById("nftupload").style.display = "none";
  };
  const handleNFT = (e) => {
    const nft = document.getElementById("nftupload");
    setStatusdrop(e.target.innerHTML);
    nft.style.display = "block";
    document.getElementById("downloadables").style.display = "none";
    document.getElementById("gift").style.display = "none";
  };

  const handleCheckbox = () => {
    const checkbox = document.getElementById("downloadables");
  };
  return (
    <div>
      <section className="physical-item digital-item create-own-bg">
        <div className="hero-section">
          <div className="container">
            <div className="row">
              <div className="col-12 right">
                <h1>
                  Create <span style={{ color: "#fff" }}>Digital</span> listing
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="physical-item-content">
          <div className="container">
            <div className="row ">
              <div className="col-sm-1"></div>
              <div className="col-sm-10">
                <Dropdown className="digital-dropdown">
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="d-flex justify-content-between align-items-center "
                  >
                    <div>{statusDrop}</div>
                    <Icon
                      icon="ep:arrow-down-bold"
                      color="#000000"
                      width="16"
                      height="16"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item className="">
                      <div onClick={(e) => handledownload(e)}>Downloadable</div>
                    </Dropdown.Item>
                    <Dropdown.Item className="">
                      <div onClick={handleGift}>Gift Card</div>
                    </Dropdown.Item>
                    <Dropdown.Item className="">
                      <div onClick={handleNFT}> NFT upload</div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <div id="gift">
                  <div className="col-1"></div>

                  <div className="col-10">
                    <h6>Image, Video, Audio, or 3d Model</h6>
                    <p className="filetype">
                      File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                      OGG, GLB, GLTF . Max size : 100MB
                    </p>

                    <div className="row mt-5">
                      <div className="col-md-4">
                        <img
                          src="../../assets/images/createyourown/chooseimg.png"
                          alt=""
                          className="img-fluid img-picker"
                        />
                      </div>

                      <div className="col-md-8">
                        <div className=" rigt-side-wrap  h-100">
                          <div className="d-flex justify-content-between flex-wrap">
                            <div>
                              <h3 className="craete-tit">Item Type :</h3>
                              <input
                                className="create-input-txt mt-2 c-name "
                                placeholder="3D Character"
                                type="text"
                              />
                            </div>
                            <div>
                              <h3 className="craete-tit">Item Name :</h3>
                              <input
                                className="create-input-txt mt-2 c-name"
                                placeholder="Cyber Ape"
                                type="text"
                              />
                            </div>
                          </div>
                          <div>
                            <h3 className="craete-tit">Quantity :</h3>
                            <input
                              className="create-input-txt mt-2"
                              placeholder="5"
                              type="number"
                            />
                          </div>

                          <div className="mt-2 d-flex justify-content-between flex-wrap">
                            <select id="time" className="s-time">
                              <option value="Select Time">Select Time</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                            </select>

                            <input type="date" className="s-date" />
                          </div>
                        </div>
                        {/* ------------ */}
                      </div>

                      <div className="col-12 mt-4">
                        <div className="text-area-section">
                          <h3 className="craete-tit mt-3">Description</h3>
                          <p className="create-txt mt-3">
                            The description will be included on the item's
                            detail page underneath its image.
                            <span className="xx">Markdown </span>
                            syntax is supported.
                          </p>
                          <textarea
                            rows="4"
                            className="textareadescription mt-3"
                            placeholder="Provide a detailed description of your item."
                          />
                        </div>
                      </div>

                      <div className="row mt-5 product-pric">
                        <h3 className="craete-tit">Price</h3>
                        <div className="col-md-4 mt-2">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="d-flex justify-content-between align-items-center "
                            >
                              <div>
                                <img
                                  src="\assets\images\icons\solona.png"
                                  alt=""
                                />
                                Clothes
                              </div>
                              <Icon
                                icon="ep:arrow-down-bold"
                                color="#000000"
                                width="16"
                                height="16"
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\solona.png"
                                    alt=""
                                  />
                                  SOL
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\dust.png"
                                    alt=""
                                  />
                                  DUST
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\usdc.png"
                                    alt=""
                                  />
                                  USDC
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="col-md-4 product-v mt-2">
                          <p className="val">0.05 SOL</p>
                        </div>

                        <div className="row">
                          <div className="col-sm-12  c-btn">
                            <button className="createitembtn me-3 mt-5">
                              Create
                            </button>
                          </div>
                          <hr className="divid" />
                        </div>

                        {/* <hr className="mt-4 divider" /> */}
                      </div>
                    </div>
                  </div>

                  <div className="col-1"></div>
                </div>

                <div id="downloadables">
                  <div className="col-1"></div>

                  <div className="col-10">
                    <h6>Image, Video, Audio, or 3d Model</h6>
                    <p className="filetype">
                      File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                      OGG, GLB, GLTF . Max size : 100MB
                    </p>

                    <div className="row mt-5">
                      <div className="col-md-4">
                        <input type="file" />
                      </div>

                      <div className="col-md-8">
                        <div className=" rigt-side-wrap  h-100">
                          <div className="d-flex justify-content-between flex-wrap">
                            <div>
                              <h3 className="craete-tit">Item Type :</h3>
                              <input
                                className="create-input-txt mt-2 c-name "
                                placeholder="3D Character"
                                type="text"
                              />
                            </div>
                            <div>
                              <h3 className="craete-tit">Item Name :</h3>
                              <input
                                className="create-input-txt mt-2 c-name"
                                placeholder="Cyber Ape"
                                type="text"
                              />
                            </div>
                          </div>
                          <div>
                            <h3 className="craete-tit">Quantity :</h3>
                            <input
                              className="create-input-txt mt-2"
                              placeholder="5"
                              type="number"
                            />
                          </div>

                          <div className="mt-2 d-flex justify-content-between flex-wrap">
                            <select id="time" className="s-time">
                              <option value="Select Time">Select Time</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                              <option value="saab">12:00</option>
                            </select>

                            <input type="date" className="s-date" />
                          </div>
                        </div>
                        {/* ------------ */}
                      </div>

                      <div className="col-12 mt-4">
                        <div className="text-area-section">
                          <h3 className="craete-tit mt-3">Description</h3>
                          <p className="create-txt mt-3">
                            The description will be included on the item's
                            detail page underneath its image.
                            <span className="xx">Markdown </span>
                            syntax is supported.
                          </p>
                          <textarea
                            rows="4"
                            className="textareadescription mt-3"
                            placeholder="Provide a detailed description of your item."
                          />
                        </div>
                      </div>

                      <div className="row mt-5 product-pric">
                        <h3 className="craete-tit">Price</h3>
                        <div className="col-md-4 mt-2">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="d-flex justify-content-between align-items-center "
                            >
                              <div>
                                <img
                                  src="\assets\images\icons\solona.png"
                                  alt=""
                                />
                                Clothes
                              </div>
                              <Icon
                                icon="ep:arrow-down-bold"
                                color="#000000"
                                width="16"
                                height="16"
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\solona.png"
                                    alt=""
                                  />
                                  SOL
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\dust.png"
                                    alt=""
                                  />
                                  DUST
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\usdc.png"
                                    alt=""
                                  />
                                  USDC
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="col-md-4 product-v mt-2">
                          <p className="val">0.05 SOL</p>
                        </div>

                        <div className="row">
                          <div className="col-sm-12  c-btn">
                            <button className="createitembtn me-3 mt-5">
                              Create
                            </button>
                          </div>
                          <hr className="divid" />
                        </div>

                        {/* <hr className="mt-4 divider" /> */}
                      </div>
                    </div>
                  </div>

                  <div className="col-1"></div>
                </div>

                <div id="nftupload">
                  <div className="col-1"></div>

                  <div className="col-10">
                    <div className="nftuploadwrapp">
                      <button className="connect-wallet-btn">
                        Connect Wallet
                      </button>
                      <h6>Choose NFT you want to list</h6>

                      <div className="all-nfts-data">
                        <label
                          id="first-label"
                          className=""
                          onMouseDown={(e) => {
                            document
                              .getElementById("nft-select-chkbox")
                              .classList.toggle("checkbox-active");

                            document
                              .getElementById("first-label")
                              .classList.toggle("label-bg");
                          }}
                        >
                          <input
                            id="nft-select-chkbox"
                            className={isActive ? "checkbox-active" : ""}
                            type="checkbox"
                          />
                          <img
                            src="../../../assets/images/physicalproduct/img1.png"
                            alt=""
                          />
                          NFT 1
                        </label>
                        <label
                          id="second-label"
                          className=""
                          onMouseDown={(e) => {
                            document
                              .getElementById("nft-select-chkbox2")
                              .classList.toggle("checkbox-active");

                            document
                              .getElementById("second-label")
                              .classList.toggle("label-bg");
                          }}
                        >
                          <input
                            id="nft-select-chkbox2"
                            className={isActive ? "checkbox-active" : ""}
                            type="checkbox"
                          />
                          <img
                            src="../../../assets/images/physicalproduct/img1.png"
                            alt=""
                          />
                          NFT 1
                        </label>

                        <label
                          id="third-label"
                          className=""
                          onMouseDown={(e) => {
                            document
                              .getElementById("nft-select-chkbox3")
                              .classList.toggle("checkbox-active");

                            document
                              .getElementById("third-label")
                              .classList.toggle("label-bg");
                          }}
                        >
                          <input
                            id="nft-select-chkbox3"
                            className={isActive ? "checkbox-active" : ""}
                            type="checkbox"
                          />
                          <img
                            src="../../../assets/images/physicalproduct/img1.png"
                            alt=""
                          />
                          NFT 1
                        </label>
                      </div>

                      <div className="list-btn-wrapp">
                        <button className="createitembtn me-3 mt-5">
                          List
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-1"></div>
                </div>
              </div>
              <div className="col-sm-1"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Digitalitem;
